/**
 * 👶 **연령 딱지 나누기** — 첫 화면·책 고르기(웹)와 `pnpm check:owner`(node 가 직접 읽는다)가 같은 판정을 쓴다.
 * 🔴 다른 파일을 가져오지 않는다 — siteText.ts 는 확장자 없는 import 가 있어 node 가 직접 못 읽는다.
 */
/** 연령 딱지는 4개까지, 하나는 40자까지 — 폰 첫 화면에서 두 줄을 넘지 않는 선 */
export const AGE_BANDS_MAX = 4;
const AGE_BAND_LEN = 40;

/**
 * 👶 `ageBands` 를 딱지로 나눈다 — 첫 화면·책 고르기·관리자 미리보기가 **같은 판정**을 쓴다.
 * 빈 조각은 버린다(`0~3세||4~7세` 의 빈 칸이 빈 딱지가 되지 않게).
 */
export function ageBandsOf(raw: string): string[] {
  return raw
    .split("|")
    .map((s) => s.trim().slice(0, AGE_BAND_LEN))
    .filter(Boolean)
    .slice(0, AGE_BANDS_MAX);
}
